/* eslint-disable react-refresh/only-export-components */
import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import Intro from './components/Intro'
import Services from './components/Services'
import Team from './components/Team'
import Quote from './components/Quote'
import References from './components/References'
import WhyBuenas from './components/WhyBuenas'
import Newsletter from './components/Newsletter'
import Contact from './components/Contact'
import Footer from './components/Footer'
import WhatsAppButton from './components/WhatsAppButton'
import CursorHeartbeat from './components/CursorHeartbeat'
import AmbientOrb from './components/AmbientOrb'
import SEO from './components/SEO'
import { useTimeOfDay } from './hooks/useTimeOfDay'
import type { RouteRecord } from 'vite-react-ssg'

function ScrollToTop() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (typeof window === 'undefined') return
    if (hash) {
      const el = document.getElementById(hash.slice(1))
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 50)
      }
    } else {
      window.scrollTo(0, 0)
    }
  }, [pathname, hash])
  return null
}

function Layout() {
  const timeOfDay = useTimeOfDay()

  useEffect(() => {
    if (typeof document === 'undefined') return
    document.body.classList.remove('time-morning', 'time-afternoon', 'time-night')
    document.body.classList.add(`time-${timeOfDay}`)
  }, [timeOfDay])

  return (
    <>
      <ScrollToTop />
      <CursorHeartbeat />
      <AmbientOrb />
      <Outlet />
    </>
  )
}

function HomePage() {
  return (
    <>
      <SEO />
      <Navbar />
      <Hero />
      <Intro />
      <Services />
      <Team />
      <Quote />
      <References />
      <WhyBuenas />
      <Newsletter />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </>
  )
}

export const routes: RouteRecord[] = [
  {
    path: '/',
    Component: Layout,
    entry: 'src/App.tsx',
    children: [
      {
        index: true,
        Component: HomePage,
      },
      {
        path: 'legal',
        lazy: async () => {
          const mod = await import('./components/Legal')
          return { Component: mod.default }
        },
      },
      {
        path: 'privacy',
        lazy: async () => {
          const mod = await import('./components/Privacy')
          return { Component: mod.default }
        },
      },
      {
        path: 'thanks',
        lazy: async () => {
          const mod = await import('./components/Thanks')
          return { Component: mod.default }
        },
      },
      {
        path: '*',
        lazy: async () => {
          const mod = await import('./components/NotFound')
          return { Component: mod.default }
        },
      },
    ],
  },
]

export default routes
